import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\AvailabilityItem\FetchAvailabilityItemController::__invoke
* @see app/Http/Controllers/AvailabilityItem/FetchAvailabilityItemController.php
* @route '/api/unavailability/items'
*/
const FetchAvailabilityItemController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchAvailabilityItemController.url(options),
    method: 'get',
})

FetchAvailabilityItemController.definition = {
    methods: ["get","head"],
    url: '/api/unavailability/items',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AvailabilityItem\FetchAvailabilityItemController::__invoke
* @see app/Http/Controllers/AvailabilityItem/FetchAvailabilityItemController.php
* @route '/api/unavailability/items'
*/
FetchAvailabilityItemController.url = (options?: RouteQueryOptions) => {
    return FetchAvailabilityItemController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AvailabilityItem\FetchAvailabilityItemController::__invoke
* @see app/Http/Controllers/AvailabilityItem/FetchAvailabilityItemController.php
* @route '/api/unavailability/items'
*/
FetchAvailabilityItemController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchAvailabilityItemController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AvailabilityItem\FetchAvailabilityItemController::__invoke
* @see app/Http/Controllers/AvailabilityItem/FetchAvailabilityItemController.php
* @route '/api/unavailability/items'
*/
FetchAvailabilityItemController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchAvailabilityItemController.url(options),
    method: 'head',
})

export default FetchAvailabilityItemController